<script>
  /* Executable code section of the program */
  //Tools importation
  import {
    isPollModalOn,
    isUpdatingPollsModal,
    temporalData,
    isReloadNecessary,
    temporalPollData,
    alertMessagge,
    isAlertOn,
  } from "../../apis/storage";
  import {
    idGenerator,
    postPollDocument,
    updatePollDocument,
  } from "../../apis/APIS";
  import { element } from "svelte/internal";

  //Auxiliary variables
  let objData = {};
  let inputArray = [];
  let counter = 0;
  let arrayLength = 3;
  let oldOptions = [];
  let lastOption = [];
  $: dinamicOptions = oldOptions;

  if ($isPollModalOn) {
    objData.questionTittle = "";
    objData.question = "";
    counter = 2;
  } else {
    objData = $temporalPollData;
    oldOptions = $temporalPollData.options.map(element=>{
      return element.optionTittle
    });
    inputArray = $temporalPollData.options;
    counter = objData.options.length;
    arrayLength = objData.options.length;
  }

  //Function to undisplay modal
  const undisplayModal = () => {
    $isPollModalOn = false;
    $isUpdatingPollsModal = false;
    objData = {};
    inputArray = [];
    oldOptions=[]
  };


  //Function to add more options to the form
  const moreOptions = () => {
    let arr = [""]
    let newArr = []
    newArr = oldOptions.concat(arr)
    oldOptions = newArr
    
  };

  //Function to delete input field
  const deleteInputField = (option,index) => {
    let element = document.getElementById(`inputPoll${index}`);
    const indexDelete = oldOptions.indexOf(option);
    if (indexDelete !== -1) {
      oldOptions.splice(indexDelete, 1);
      element.remove();
    }
  };
    //Function to display alert
    const displayAlert = () => {
    $isAlertOn = true;
  };

  //function to create a poll
  const addPollDocument = () => {
    if (
      inputArray.length >= 2 &&
      objData.questionTittle !== "" &&
      objData.question !== ""
    ) {
      objData.event = $temporalData.tittle;
      objData.id = idGenerator();
      objData.isActivePoll = false
      objData.options = inputArray.concat(oldOptions);
      objData.options = objData.options.filter(element => element !== "");
      objData.options = objData.options.map(element => {
        return {optionTittle:element,votes:[]}
      })
      postPollDocument(objData.id, objData).then(() => {
        $alertMessagge = "Poll created successfully"
        $isReloadNecessary = true
        displayAlert()
        $isPollModalOn = false;
      })
      .catch(()=>{
        $alertMessagge = "Could not create the poll, please try again."
        displayAlert()
      })
    } else {
      $alertMessagge = "You need to fill all fields to create the poll (at least 2 answer options)"
      displayAlert()
    }
  };
  //Function to update a poll question
  const updatePoll = () => {
    objData.options = oldOptions.filter(element => element !== "");
    objData.options = oldOptions.map(element => {
        return {optionTittle:element,votes:[]}
      })
    updatePollDocument(objData, objData.id).then(() => {
      $alertMessagge = "The information has been updated successfully."
      $isUpdatingPollsModal = false;
      objData = {};
      inputArray = [];
      $isReloadNecessary = true
      displayAlert()
    })
    .catch(()=>{
      $alertMessagge = "An error occurred while updating the information."
      displayAlert()
    })
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  <div class="contentContainer">
    <div class="headerContent">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-lg icon"
        viewBox="0 0 16 16"
        on:click={undisplayModal}
        on:keypress={undisplayModal}
      >
        <path
          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
        />
      </svg>
    </div>
    <div class="bodyContent">
      <div class="headerBody">
        {#if $isPollModalOn}
          <h2 class="questionTittle">Add Question</h2>
        {:else}
          <h2 class="questionTittle">Update Question</h2>
        {/if}
      </div>
      <div class="questionInputTittle">
        <div class="form-floating inputTittle">
          <input
            type="text"
            class="form-control"
            placeholder="Option"
            bind:value={objData.questionTittle}
          />
          <label for="floatingPassword">Question Tittle</label>
        </div>
        <div class="form-floating inputTittle">
          <input
            type="text"
            class="form-control"
            placeholder="Option"
            bind:value={objData.question}
          />
          <label for="floatingPassword">Question</label>
        </div>
      </div>
      <div class="questionOptions">
        <h3 class="questionTittle">Options</h3>
        <div class="optionContainer">
          {#if $isPollModalOn}
            <div class="inputCompleteContainer" id="inputPoll0">
              <div class="form-floating inputOptions">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Option"
                  bind:value={inputArray[0]}
                />
                <label for="floatingPassword">Option 1</label>
              </div>
            </div>
            <div class="inputCompleteContainer" id="inputPoll1">
              <div class="form-floating inputOptions">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Option"
                  bind:value={inputArray[1]}
                />
                <label for="floatingPassword">Option 2</label>
              </div>
            </div>
            <!-- Section to new options -->
            {#each oldOptions as option, index}
              <div class="inputCompleteContainer" id="inputPoll{index+2}">
                <div class="form-floating inputOptions">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Option"
                    bind:value={option}
                  />
                  <label for="floatingPassword">Option {index + 3}</label>
                </div>
                <div class="iconContainer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-dash-circle icon"
                    viewBox="0 0 16 16"
                    on:click={() => deleteInputField(option,index + 2)}
                    on:keypress={() => deleteInputField(option,index + 2)}
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                    />
                    <path
                      d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"
                    />
                  </svg>
                </div>
              </div>
            {/each}
          {:else}
            <!-- Section to update options -->
            {#each oldOptions as option, index}
              <div class="inputCompleteContainer" id="inputPoll{index}">
                <div class="form-floating inputOptions">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Option"
                    bind:value={option}
                  />
                  <label for="floatingPassword">Option {index + 1}</label>
                </div>
                <div class="iconContainer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-dash-circle icon"
                    viewBox="0 0 16 16"
                    on:click={() => deleteInputField(option,index)}
                    on:keypress={() => deleteInputField(option,index)}
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                    />
                    <path
                      d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"
                    />
                  </svg>
                </div>
              </div>
            {/each}
          {/if}
        </div>
        <div class="addOptionContainer">
          <button class="actionBtn hoverActionBtn" on:click={moreOptions}
            >Add More Options</button
          >
        </div>
      </div>
    </div>
    <div class="footerContent">
      <button class="actionBtn" on:click={undisplayModal}>Close</button>
      {#if $isPollModalOn}
        <button class="actionBtn hoverActionBtn" on:click={addPollDocument}
          >Create Poll</button
        >
      {:else}
        <button class="actionBtn hoverActionBtn" on:click={updatePoll}
          >Update Poll</button
        >
      {/if}
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .principalContainer {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.514);
    padding: 30px;
    z-index: 888;
    display: flex;
    justify-content: center;
  }
  /* Content container styles */
  .contentContainer {
    width: 80%;
    height: auto;
    max-height: 90vh;
    overflow: auto;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Header content styles */
  .headerContent {
    width: 90%;
    padding: 20px;
    display: flex;
    justify-content: flex-end;
  }
  .icon {
    color: red;
  }
  .icon:hover {
    cursor: pointer;
  }
  /* Body content styles */
  .bodyContent {
    width: 90%;
    height: auto;
  }
  /* header */
  .headerBody {
    width: 100%;
  }
  .questionTittle {
    padding: 10px 20px;
    border-bottom: 1px solid gray;
  }
  /* body */
  /* Body tittle styles */
  .questionInputTittle {
    display: flex;
    padding: 20px;
    width: 100%;
  }
  .inputTittle {
    width: 50%;
    margin: 5px;
  }
  /* Body question options styles */
  .inputCompleteContainer {
    width: 50%;
    display: flex;
  }
  .questionOptions {
    padding: 10px;
  }
  .optionContainer {
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
  }
  .inputOptions {
    width: 80%;
    margin: 5px;
  }
  .addOptionContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }
  .iconContainer {
    width: 20%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  /* Buttons styles */
  .actionBtn {
    width: 250px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .hoverActionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* Footer content */
  .footerContent {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  /* Principal styles */
  .principalContainer {
    padding: 10px;
  }
  /* Content container styles */
  .contentContainer {
    width: 100%;
    height: auto;
    max-height: 90vh;
    overflow: auto;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* body */
  /* Body tittle styles */
  .questionInputTittle {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;
  }
  .inputTittle {
    width: 100%;
    margin: 5px;
  }
  /* Body question options styles */
  .inputCompleteContainer {
    width: 100%;
    display: flex;
  }
  .questionOptions {
    padding: 10px;
  }
  .optionContainer {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 10px;
  }
  .inputOptions {
    width: 100%;
    margin: 5px;
  }
  }
  /* End of the section */
</style>
